import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-modificados',
  templateUrl: './modificados.component.html',
  styleUrl: './modificados.component.css'
})
export class ContratosModificadosComponent {

}
